import React from 'react';
import { useParams } from 'react-router-dom';
import RegisterEmail from './RegisterEmail';
import RegisterWizard from './RegisterWizard';
import { RegistrationFormContextProvider } from './RegistrationFormContext';

const Register: React.FC = () => {
  const { registrationKey } = useParams();

  if (!registrationKey) {
    return <RegisterEmail />;
  }

  return (
    <RegistrationFormContextProvider>
      <RegisterWizard registrationKey={registrationKey} />
    </RegistrationFormContextProvider>
  );
};

export default Register;
